// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"bf540643","487":"6233d9da","638":"411f6ca2","670":"dbe66e5c","767":"54de2519","916":"1b9f5c8c","943":"50d3b1bd"}[chunkId] + ".chunk.js";
};